<mat-dialog-content class="medlem-rediger-dialog-innhold">
  <medlem-rediger [medlem]="medlem"
                  [gruppe]="gruppe"
                  (vedLagret)="vedLagret()"
                  (vedAvbryt)="avbryt()"/>
</mat-dialog-content>
